@if (loading) {
  <div
    class="d-flex spinner-wrapper justify-content-center">
    <ix-spinner size="large"></ix-spinner>
  </div>
}
<ix-workflow-steps
  [class.invisible]="loading"
  [selectedIndex]="selectedCategory"
  [vertical]="true"
  class="cursor sticky-top top-10"
  clickable="true"
  >
  @for (category of categories; track category; let i = $index) {
    <ix-workflow-step
      (click)="setFormIndex(i)"
      [status]="categoriesWithErrors.includes(category.name) ? 'error' : 'open'"
      id="{{'batteryPassWorkflowStep.' + i}}"
      onkeypress=""
      >{{ category.translation.label | translate }}
    </ix-workflow-step>
  }
</ix-workflow-steps>
